import React from 'react'
import {Nav, Navbar} from 'react-bootstrap';

function BottomComp() {
    
    return (

        <div class="row  septintasblokas text-white justify-content-center flex-row">
        <Navbar bg="none" className=" navbar-dark ">
            <Nav className="flex-column flex-sm-row" >
            <Nav.Item  className="px-3" style={{ fontWeight: 600 }}>
                <Nav.Link className="text-center"  href="https://www.facebook.com/do.natas.73" target="_blank">FACEBOOK</Nav.Link>
            </Nav.Item>
            <Nav.Item className="px-3" style={{ fontWeight: 600 }}>
                <Nav.Link className="text-center"  href="https://www.linkedin.com/in/donatas-m" target="_blank">LINKEDIN</Nav.Link>
            </Nav.Item>
            <Nav.Item className="px-3" style={{ fontWeight: 600 }}>
                <Nav.Link className="text-center"  href="https://github.com/donataskitm" target="_blank">GITHUB</Nav.Link>
            </Nav.Item>
            <Nav.Item className="px-3" style={{ fontWeight: 600 }}>
                <Nav.Link className="text-center"  href="https://orcid.org/0000-0002-8253-684X" target="_blank">ORCID</Nav.Link>
            </Nav.Item>
            <Nav.Item className="px-3" style={{ fontWeight: 600 }}>
                <Nav.Link className="text-center" href="https://www.flickr.com/photos/192898118@N08" target="_blank">FLICKR</Nav.Link>
            </Nav.Item>
            </Nav>
        </Navbar>
      </div>
    )
}

export default BottomComp